/**
 * ProtectedRoute.jsx - DB-backed route guard.
 *
 * If the user is signed in (token in localStorage + AuthProvider
 * mounted), render `children`. Otherwise redirect to /login and
 * remember the requested URL so we can come back after sign-in.
 */

import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./apiAuth.jsx";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--ink-3, #888)",
      }}>
        Checking session…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}